const infoTestimonialInputs = [
    { id: "title", text: "Title", icon: "fa-tag", value: ""},
    { id: "detail", text: "Detail", icon: "fa-file-alt", value: ""},
    { id: "video", text: "Video", icon: "fa-video", value: ""}
];

const taxInputs = [
    { id: "taxAmount", text: "Tax Amount", value: ""},
    { id: "taxNumber", text: "Tax Number", value: ""},
    { id: "taxName", text: "Tax Name", value: ""},
    { id: "taxPrefix", text: "Tax Prefix", value: ""}
]

const socialMedias = [
    {id: 'facebook', label: 'Facebook', icon: 'fab fa-facebook', value: ""},
    {id: 'instagram', label: 'Instagram', icon: 'fab fa-instagram', value: ""},
    {id: 'fave', label: 'Fave', icon: '@/assets/image/icon/fave.png', value: ""},
    {id: 'whatsapp', label: 'WhatsApp', icon: 'fab fa-whatsapp', value: ""},
    {id: 'waze', label: 'Waze', icon: 'fab fa-waze', value: ""},
    {id: 'webWaze', label: 'Web Waze', icon: 'fab fa-waze', value: ""},
    {id: 'googleMap', label: 'Google Map', icon: 'fas fa-map-marked-alt', value: ""},
    {id: 'webGoogleMap', label: 'Web Google Map', icon: 'fas fa-map-marked-alt', value: ""},
]

const outletSetup = [
    {id: 'enableMultiLogin', text: 'Multi Login', value: false},
    {id: 'enableManual', text: 'Manual', value: false},
    {id: 'enablePriceControl', text: 'Price Control', value: false},
    {id: 'enableMbrName', text: 'Member Name', value: false},
    {id: 'enableMbrDob', text: 'Member D.O.B', value: false},
    {id: 'enableMobileReceipt', text: 'e-Receipt', value: false},
    {id: 'enableMobileBook', text: 'Booking', value: false},
]

const memberLastVisits = [
    { id: "all", text: "All Visit", tooltip:""},
    { id: "one", text: "Within 1 Month", tooltip:""},
    { id: "three", text: "Within 1 to 3 Months", tooltip:""},
    { id: "six", text: "Within 3 to 6 Months", tooltip:""},
    { id: "more", text: "Over 6 Months", tooltip:""}
];

const memberBirthdays = [
    { id: "all", text: "All Birthday"},
    { id: "today", text: "Today"},
    { id: "last", text: "Last Month"},
    { id: "this", text: "This Month"},
    { id: "next", text: "Next Month"}
]

export default{
    infoTestimonialInputs: infoTestimonialInputs,
    taxInputs: taxInputs,
    socialMedias: socialMedias,
    outletSetup: outletSetup,
    memberLastVisits: memberLastVisits, 
    memberBirthdays: memberBirthdays
}